module.exports = __webpack_public_path__ + "static/img/6.2f7d8ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/6.png
// module id = YUau
// module chunks = 0